import { selector } from '@poa/state';
import { filteredData, isAllColumnsSelected } from './transfers.selectors';

const columns = [
  {
    name: 'photo',
    label: 'Фото',
    width: 60,
    sectionId: 'section_1',
    isSelected: true
  },
  {
    name: 'transfer_date',
    label: 'Дата трасфера',
    width: 170,
    sectionId: 'section_1',
    isSelected: true
  },
  {
    name: 'account_full_name',
    label: 'ФИО',
    width: 170,
    sectionId: 'section_1',
    isSelected: true
  },
  {
    name: 'nickname',
    label: 'Ник',
    width: 170,
    sectionId: 'section_1',
    isSelected: true
  },
  {
    name: 'from_full_name',
    label: 'От',
    width: 170,
    sectionId: 'section_1',
    isSelected: true
  },
  {
    name: 'to_full_name',
    label: 'Кому',
    width: 170,
    sectionId: 'section_1',
    isSelected: true
  }
];

export const transfersInitialState = {
  transfers: {
    ui: {
      favorites: []
    },
    data: [],
    meta: {
      isLoading: false,
      hasError: false,
      loaded: false,
      operators: [],
      accounts: [],
      teamleads: [],
      managers: [],
    },
    filters: {
      startDate: null,
      endDate: null,

      filtering: {
        selected: null,
        options: []
      },

      columnSettings: {
        // default preset
        currentPresetId: 0,
        // presets from server
        availablePresets: [
          // preset model
          {
            id: 0,
            label: 'по умолчанию',
            columnsConfiguration: columns
          }
        ],
        lastSelectedPresetColumns: []
      },
      isDecimal: false,
      search: ''
    },
    selectors: {
      filteredData,
      isAllColumnsSelected,
      selectedPreset: selector(store => {
        return store.transfers.filters.columnSettings.availablePresets.find(
          preset => preset.id === store.transfers.filters.columnSettings.currentPresetId
        );
      }),
      currentPresetColumnsList: selector(store =>
        store.transfers.selectors.selectedPreset.columnsConfiguration.map(column => column.name)
      )
    }
  }
};
